<div *ngFor="let noteSection of noteSections" class="noteSeperator">
  <div class="container">
    <div style="display: flex; justify-content: start">
      <i [ngClass]="noteSection.iconClass || ''">&nbsp;</i>
      <h3>{{ noteSection.title }}</h3>
    </div>
    <p style="margin: 0" [innerHTML]="noteSection.body || '' | mdToHtml"></p>
  </div>
</div>
